import { AppMode } from 'app/features/settings/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { LocationType } from 'app/shared/features/location-selector/models';
import { MeasurementType } from 'app/shared/models/measurement-type';
import { getStateBySupportedLocationType } from 'app/state/manual-flow/manual-flow.utils';
import { ComponentState } from 'app/state/manual-flow/select-state';

export function getMeasurementTypeState(measurementType: MeasurementType) {
    return measurementType === MeasurementType.containerWeight
        ? ComponentState.SelectAmountResult
        : ComponentState.SelectAmountAndProductBox;
}

export function skipEmployeeSelection(appMode?: AppMode) {
    return appMode === 'personal' ? ComponentState.SelectContainer : ComponentState.SelectEmployee;
}

export function skipLocationSelection(activity: Activity, appMode?: AppMode) {
    if (activity.locationType === null || activity.locationType === LocationType.Site)
        return skipEmployeeSelection(appMode);
    else return getStateBySupportedLocationType(activity.locationType);
}

export function skipBatchSelection(activity: Activity, appMode?: AppMode) {
    return activity.isBatchInputRequired
        ? ComponentState.SelectBatch
        : skipLocationSelection(activity, appMode);
}
